import {inject, Injectable} from '@angular/core';
import {RecordsDataRequestQueryParams} from "../../../../types/records-table.types";
import {
  GetDefectQueryParams,
  ProductCardDefect,
  ProductCardDefectValue,
  UpdateFeedbackDefectsParams
} from "../types/defects-modal.types";
import {DefectsModalApiService} from "./defects-modal-api.service";
import {defaultRecordsDataRequestQueryParams} from "../../../../models/default-records-data-request-query-params";

@Injectable({
  providedIn: 'root'
})
export class DefectsModalService {
  private defectsModalApiService: DefectsModalApiService = inject(DefectsModalApiService);

  public getDefectQueryParams({ productCardId, productCardDefectId }: GetDefectQueryParams): RecordsDataRequestQueryParams {
    return  {
      ...defaultRecordsDataRequestQueryParams,
      size: undefined,
      ...(productCardDefectId ? { productCardDefectId: productCardDefectId } : {}),
      ...(productCardId ? { productCardId: productCardId } : {}),
    };
  }

  public getProductCardsDefects(queryParams: RecordsDataRequestQueryParams): Promise<Array<ProductCardDefect>> {
    return new Promise((resolve, reject) => {
      this.defectsModalApiService.getProductCardsDefects(queryParams).subscribe({
        next: (productCardDefects) => resolve(productCardDefects),
        error: (error) => reject(error)
      });
    });
  }

  public getProductCardsDefectValues(queryParams: RecordsDataRequestQueryParams): Promise<Array<ProductCardDefectValue>> {
    return new Promise((resolve, reject) => {
      this.defectsModalApiService.getProductCardsDefectValues(queryParams).subscribe({
        next: (productCardDefectValues) => resolve(productCardDefectValues),
        error: (error) => reject(error)
      });
    });
  }

  public updateFeedbackDefects(updateFeedbackDefectsParams: UpdateFeedbackDefectsParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.defectsModalApiService.updateFeedbackDefects(updateFeedbackDefectsParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
